import { useLang } from 'hooks/lang';

import { FullProjectIssue } from 'entities';

import { Column } from 'components/Blocks';
import { CreateIssueButton } from './CreateButton';

interface Props {
  registerNewIssue: (newIssue: FullProjectIssue) => void;
}

export function NoIssue({ registerNewIssue }: Props) {
  const { t } = useLang();

  return (
    <Column className="pt-12" alignItems="center">
      <h6>{t('no-issue-title')}</h6>

      <Column alignItems="center" gap="0">
        <span>{t('register-problems')}</span>

        <span>{t('involve-anyone-from-project')}</span>
      </Column>

      <CreateIssueButton registerNewIssue={registerNewIssue} />
    </Column>
  );
}
